import React from "react";

/**
 * @component ExpenseAddIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <ExpenseAddIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const ExpenseAddIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="ExpenseAddIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M19 14v3h3v2h-3v3h-2v-3.001L14 19v-2l3-.001V14h2zm1-11a2 2 0 011.994 1.85L22 5v7h-2V5H4v14h8v2H4a2 2 0 01-1.995-1.85L2 19V5c0-1.06.81-1.919 1.85-1.995L4 3h16zm-9 4v1h2v2H9v1h3a1 1 0 01.993.883L13 12v3a1 1 0 01-.883.993L12 16h-1v1H9v-1H7v-2h4v-1H8a1 1 0 01-.993-.883L7 12V9a1 1 0 01.883-.993L8 8h1V7h2z"
        fillRule="evenodd"
      />
    </svg>
  )
);
ExpenseAddIcon.displayName = "ExpenseAddIcon";
export default ExpenseAddIcon;
